import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import FormControl from '@material-ui/core/FormControl'
import Typography from '@material-ui/core/Typography'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import { useWizardFormContext } from 'components/wizard-form/context'

const SelectLocation = () => {
  const { errors, control } = useFormContext()
  const {
    extraData: { coachFacilities },
  } = useWizardFormContext()
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box mb={4}>
        <Typography variant="h4" align="center">
          Select the location where this event will be held.
        </Typography>
      </Box>
      <Container maxWidth="xs">
        <FormControl error={!!errors.locationId} variant="outlined" fullWidth>
          <InputLabel id="category">Select location</InputLabel>
          <Controller
            name="locationId"
            control={control}
            render={({ onChange, value }, _) => (
              <Select
                labelId="location"
                label="Select location"
                defaultValue={coachFacilities[0]}
                value={value || ''}
                onChange={onChange}
                data-cy={'location'}
              >
                {coachFacilities.map(facility => (
                  <MenuItem key={facility.id} value={facility.id}>
                    {facility.name}
                  </MenuItem>
                ))}
              </Select>
            )}
          />
          {errors.locationId ? (
            <Typography variant="caption" color="error">
              Please select a location
            </Typography>
          ) : null}
        </FormControl>
      </Container>
    </Box>
  )
}

export default SelectLocation
